/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import EnhancedTable from "../../common_components/Tables/EnhancedTable";
import Page from "../../common_components/Page/Page";
import Form from "./Form";
import { useDispatch } from "react-redux";
import { notifySuccess, notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import SettingsContext from "../SettingsContext";
import Header from "components/common_components/Header";
import Icon from "components/common_components/Icon";
import Button from "components/common_components/Button";

const headCells = [
    { index: 1, id: "code", disablePadding: false, label: "Code" },
    { index: 2, id: "name", disablePadding: true, label: "Name" },
    { index: 3, id: "description", disablePadding: true, label: "Description" },
];

function POSCategories(props) {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [mode, setMode] = useState("listOnly");
    const [itemToEdit, setItemToEdit] = useState({});
    const [pageableData, setPageableData] = useState(undefined);
    const defaultRequestData = {
        filter: {},
        orderBy: "code",
        orderDirection: "asc",
        pageNumber: 0,
        pageSize: 5,
    };

    const { POSCategories } = useContext(SettingsContext);

    function getPOSCategories(requestData = defaultRequestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        POSCategories.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    useEffect(() => {
        getPOSCategories();

        return () => {
            setData([]);
            setItemToEdit(undefined);
        };
    }, []);

    function onRowClickHandler(item) {
        setItemToEdit(item);
        setMode("update");
    }

    function onCancelHandler() {
        setItemToEdit(undefined);
        setMode("listOnly");
    }

    function onSuccess(_, setSubmitting) {
        setSubmitting(false);
        onCancelHandler();
        dispatch(notifySuccess(`POS Category ${mode === "add" ? "created" : "updated"} successfully!`));
        getPOSCategories();
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            onCancelHandler();
            dispatch(notifyError(error));
        }
        setSubmitting(false);
    }

    async function onSubmitHandler(values, { setSubmitting, setErrors }) {
        const { code, ...payload } = values;

        const apiCall = mode === "add" ? POSCategories.add : POSCategories.update;

        apiCall({
            payload: {
                id: mode === "update" ? itemToEdit.id : null,
                code: code.trim().toUpperCase(),
                ...payload,
            },
            onSuccess: (response) => onSuccess(response, setSubmitting),
            onError: (error) => onError(error, setSubmitting, setErrors),
        });
    }

    function onDeleteSuccess() {
        dispatch(notifyInfo("Removed successfully!"));
        getPOSCategories();
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        POSCategories.deleteAll({
            ids: selectedItems,
            onSuccess: onDeleteSuccess,
            onError: onDeleteError,
        });
    }

    function filterBuilder(filterValue) {
        return filterValue
            ? {
                  code: filterValue,
                  name: filterValue,
                  description: filterValue,
              }
            : {};
    }

    function onAddHandler() {
        setItemToEdit(undefined);
        setMode("add");
    }

    return (
        <Page>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    {mode !== "listOnly" && (
                        <Form
                            data={itemToEdit}
                            mode={mode}
                            onSubmit={onSubmitHandler}
                            onCancel={onCancelHandler}
                            title={mode === "add" ? "New POS Category" : "Update POS Category"}
                        />
                    )}
                    {mode === "listOnly" && (
                        <>
                            <Header title="POS Categories">
                                <Button primary onClick={onAddHandler}>
                                    <Icon name="add" size="md" color="white" />
                                    <span>Add</span>
                                </Button>
                            </Header>
                            <div className="layout">
                                <EnhancedTable
                                    headCells={headCells}
                                    data={data}
                                    defaultOrder={{
                                        order: defaultRequestData.orderDirection,
                                        orderBy: defaultRequestData.orderBy,
                                    }}
                                    selectable
                                    keyColumnName="id"
                                    onRowClick={onRowClickHandler}
                                    onDelete={onDeleteHandler}
                                    onRequestData={getPOSCategories}
                                    filterBuilder={filterBuilder}
                                    pageableData={pageableData}
                                />
                            </div>
                        </>
                    )}
                </>
            )}
        </Page>
    );
}

export default withRouter(POSCategories);
